import { Field } from 'formik';

export const TextareaField = ({ className = '', ...props }) => {
  return <Field className="tribute-text-area tribute-text-field" rows={10} as="textarea" {...props} />;
};
